import React from 'react';

const Blog = () => {
    return (
        <div className='px-20 mt-16 bg-white'>
            <h1 className='text-center text-5xl font-bold mb-10'>Welcome to My Blog Post</h1>
            <h2>Coming soon</h2>
            <div className='py-32'>
            </div>
        </div>
    );
};

export default Blog;